export const TYPE = {
  static: 'static',
};

export const VARIANT = {
  error: 'danger',
  warning: 'warning',
};
